export function copyUint8Array(data: Uint8Array): Uint8Array<ArrayBuffer> {
  const copy = new Uint8Array(data.byteLength);
  copy.set(data);
  return copy;
}

export function copyFloat32Array(
  data: Float32Array
): Float32Array<ArrayBuffer> {
  const copy = new Float32Array(data.length);
  copy.set(data);
  return copy;
}

export function uint8ArrayToArrayBuffer(data: Uint8Array): ArrayBuffer {
  return copyUint8Array(data).buffer;
}
